import { render, staticRenderFns } from "./events-side-bar.vue?vue&type=template&id=179ad0d8&"
import script from "./events-side-bar.vue?vue&type=script&lang=js&"
export * from "./events-side-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports